/**
 * Not-a-member state for issue #146 — the sibling of `NoProjects`.
 *
 * `NoProjects` covers "no sites at all" (org module). This covers the gap
 * the 2026-09-15 clear-republish exposed: the topbar shows a valid site
 * (org module membership) but the user has no live `user_site` row on the
 * minetwin console, so every admin view returns empty and the pages used
 * to render their misleading "no orientations / no sessions / no workers"
 * empty states. Those empty states are now reserved for real members of
 * genuinely empty sites.
 *
 * Org admins are deliberately NOT special-cased: they short-circuit
 * `require_site_admin` on writes but still get empty reads without a
 * `user_site` row, so the gate applies to them too — the copy tells them
 * they can add themselves.
 */
export function NoSiteMembership({
  pageName,
  siteName,
}: {
  pageName: string;
  siteName: string;
}) {
  return (
    <>
      <div className="page-head">
        <div>
          <h1 style={{ margin: 0, fontSize: 18 }}>{pageName}</h1>
          <div style={{ color: 'var(--muted)', fontSize: 12, marginTop: 2 }}>
            Per-site surface · no membership on this site
          </div>
        </div>
      </div>
      <div className="page-body">
        <div
          className="card"
          style={{
            padding: 24,
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            alignItems: 'flex-start',
            maxWidth: 560,
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 600 }}>
            You are not a member of {siteName} on this console yet
          </div>
          <div style={{ fontSize: 12.5, color: 'var(--muted)' }}>
            The site exists and you can see it in the topbar, but your
            account has no workforce membership here — so {pageName} has
            nothing it is allowed to show you.
          </div>
          <div style={{ fontSize: 12.5, color: 'var(--muted)' }}>
            Ask a site admin to add you on the <b>Workforce</b> page. If
            you are the admin, add yourself there — Workforce stays open
            for exactly that.
          </div>
        </div>
      </div>
    </>
  );
}
